module.exports = __webpack_public_path__ + "assets/img/share-icon-1.41010ac4.png";